"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const scale_1 = require("../../utils/scale");
const CustomText_1 = __importDefault(require("../text/CustomText"));
// @ts-ignore
const react_ios_switch_1 = __importDefault(require("react-ios-switch"));
const SwitchView = (props) => {
    const { defaultValue = false, title, description = '', onChangeValue, style = {} } = props;
    const [switchActive, setSwitchActive] = (0, react_1.useState)(defaultValue);
    (0, react_1.useEffect)(() => {
        setSwitchActive(defaultValue);
    }, [defaultValue]);
    return (react_1.default.createElement(react_native_1.View, { style: [styles.item, style] },
        react_1.default.createElement(react_native_1.View, { style: styles.switchView },
            react_1.default.createElement(CustomText_1.default, { style: styles.itemTitle }, title),
            react_1.default.createElement(react_ios_switch_1.default, { checked: switchActive, onChange: (val) => {
                    const value = val ? 1 : 0;
                    setSwitchActive(val);
                    onChangeValue(value);
                }, onColor: "#65C466", offColor: "#DDDDDD" })),
        react_1.default.createElement(CustomText_1.default, { style: styles.itemDescription }, description)));
};
exports.default = SwitchView;
const styles = react_native_1.StyleSheet.create({
    item: {
        width: '100%',
        paddingHorizontal: (0, scale_1.scale)(16),
        paddingVertical: (0, scale_1.scale)(12),
        borderBottomWidth: (0, scale_1.scale)(1),
        borderColor: '#DDDDDD'
    },
    switchView: {
        width: '100%',
        flexDirection: 'row',
        alignItems: 'center'
    },
    itemTitle: {
        flex: 1,
        fontSize: (0, scale_1.moderateScale)(15),
        lineHeight: (0, scale_1.moderateScale)(22.5),
        color: '#292A33'
    },
    itemDescription: {
        width: '100%',
        paddingRight: (0, scale_1.scale)(82),
        fontSize: (0, scale_1.moderateScale)(11),
        lineHeight: (0, scale_1.moderateScale)(18.7),
        color: '#888888'
    },
});
